  $(document).ready(function() {   
    $(document).on("change", ".upload-btn-wrapper input[type='file']" , function() {      
      var i = $(this).parent().find('.btn-upload').clone();
      var file = $(this)[0].files[0].name;   
      var exts = ['jpg','png','jpeg'];
      // first check if file field has any value
      if ( file ) {
        // split file name at dot
        var get_ext = file.split('.');
        // reverse name to check extension
        get_ext = get_ext.reverse();
        // check file type is valid as given in 'exts' array
        if ( $.inArray ( get_ext[0].toLowerCase(), exts ) > -1 ){
          $(this).next('.image-name').text(file);
        } else {
          $(this).next('.image-name').text('');
        }
      }   
      //$(this).parent().find('.btn-upload').text(file);
      //$(this).next('.image-name').text(file);
    });
    /*$('.upload-btn-wrapper input[type="file"]').change(function() {      
      var i = $(this).parent().find('.btn-upload').clone();
      var file = $(this)[0].files[0].name;      
      $(this).parent().find('.btn-upload').text(file);
    });*/  
    $(document).on("click", ".com-checkbox input[type='checkbox']" , function() {      
      if($(this).prop('checked')){
        $(this).prev('label').removeClass('text_grey');
        $(this).prev('label').addClass('text_pink')
      }else{
        $(this).prev('label').removeClass('text_pink');
        $(this).prev('label').addClass('text_grey')
      }
    });    
   });   

   window.addEventListener('load', function () {
  //   $('.com-checkbox input[type="checkbox"]').click(function(){
  //     alert("in");
  //     if($(this).prop("checked") == true){
  //         alert("Checkbox is checked.");
  //     }
  //     else if($(this).prop("checked") == false){
  //         alert("Checkbox is unchecked.");
  //     }
  // });
      

    });
  //   $(document).on('click', 'label input:checkbox').click(function() {
  //     $(this.parentNode).toggleClass('active', this.checked);
  // });
    //alert("hi");
  //   $('.com-checkbox input[type="checkbox"]').change(function(){
  //     $(this).parent('.com-checkbox').addClass("change-label");
  //     // if($(this).is(":checked")) {
  //     //  $('.com-checkbox').addClass("change-label");
  //     //   //$(this).parent('.com-checkbox').addClass("change-label");
  //     //     //$('div.menuitem').addClass("menuitemshow");
  //     // } else {
  //     //  // $(this).parent().find(label).removeClass("change-label");
  //     //     //$('div.menuitem').removeClass("menuitemshow");
  //     //     //$(this).parent('.com-checkbox').removeClass("change-label");
  //     //     $('.com-checkbox').removeClass("change-label");
  //     // }
  // });
  //   }, false);
  //  jQuery(window).onload(function() {
   
  //   $('.com-checkbox input').click(function(){
  //     $(this).parent('.com-checkbox').addClass("change-label");
  //     // if($(this).is(":checked")) {
  //     //  $('.com-checkbox ').addClass("change-label");
  //     //   //$(this).parent('.com-checkbox').addClass("change-label");
  //     //     //$('div.menuitem').addClass("menuitemshow");
  //     // } else {
  //     //  // $(this).parent().find(label).removeClass("change-label");
  //     //     //$('div.menuitem').removeClass("menuitemshow");
  //     //     //$(this).parent('.com-checkbox').removeClass("change-label");
  //     //     $('.com-checkbox ').removeClass("change-label");
  //     // }
  // });

  // $(".com-checkbox input.ng-valid").change(function() {
  //   $(this).parent('.com-checkbox').toggleClass("selected", this.checked);
  // });

 


// WEBPACK FOOTER //
// src/common.js